import once from '@lib/once';

function setupToggleActive(el: HTMLElement): void {
    el.addEventListener('click', () => {
        if (el.dataset['toggleActive']) {
            const targets = document.querySelectorAll(el.dataset['toggleActive']);
            targets.forEach((target) => target.classList.toggle('is-active'));
        }
    });
}

window.Drupal.behaviors['toggleActive'] = {
    attach(context: HTMLElement | Document) {
        context.querySelectorAll<HTMLElement>('[data-toggle-active]').forEach((el) => {
            once('data-toggle-active', setupToggleActive, [el]);
        });
    },
};
